import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["days", "hours", "minutes", "seconds"]
  static values = { deadline: String }

  connect() {
    this.tick()
    this.interval = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    if (this.interval) clearInterval(this.interval)
  }

  tick() {
    const delta = new Date(this.deadlineValue).getTime() - Date.now()
    if (delta <= 0) {
      this.element.dataset.expired = ""
      clearInterval(this.interval)
      return
    }
    const days    = Math.floor(delta / 86_400_000)
    const hours   = Math.floor((delta % 86_400_000) / 3_600_000)
    const minutes = Math.floor((delta % 3_600_000) / 60_000)
    const seconds = Math.floor((delta % 60_000) / 1000)
    if (this.hasDaysTarget)    this.daysTarget.textContent    = String(days)
    if (this.hasHoursTarget)   this.hoursTarget.textContent   = String(hours).padStart(2, "0")
    if (this.hasMinutesTarget) this.minutesTarget.textContent = String(minutes).padStart(2, "0")
    if (this.hasSecondsTarget) this.secondsTarget.textContent = String(seconds).padStart(2, "0")
  }
}
